import { BaseEntity, Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { ICheck } from './interface/ICheck';

@Entity('check')
export class Check extends BaseEntity implements ICheck{
  @PrimaryGeneratedColumn()
  id: number;

  @Column({ nullable: false, unique: true })
  name: string;

  @Column({ nullable: false, unique: true })
  value: string;
}
